export default __webpack_public_path__ + "static/media/Virtual1.9c91c509.webp";